module.exports = __webpack_public_path__ + "img/social-rewards.d586780b.png";